import React from 'react';
// slider
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination, Autoplay } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";

import './Portfolio.css';


const Portfolio = () => {

    return (
        <>
            <div id="portfolio">
                <div className="container">
                    <div className="section__header text-center">
                        <h2 className="section__title">I build & design stuff</h2>
                        <p className="section__subtitle">
                        Open source projects, web apps and experimentals.
                        </p>
                    </div>
                    <div className="portfolio__slider">
                        <Swiper
                            effect={"coverflow"}
                            grabCursor={true}
                            coverflowEffect={{
                                rotate: 50,
                                stretch: 0,
                                depth: 100,
                                modifier: 1,
                                slideShadows: true,
                            }}
                            pagination={{
                                clickable: true,
                            }}
                            modules={[EffectCoverflow, Pagination, Autoplay]}
                            className="mySwiper"
                            autoplay={true}
                            breakpoints={{
                                768: {
                                    slidesPerView: 2,
                                    spaceBetween: 30,
                                },
                                1024: {
                                    slidesPerView: 3,
                                    spaceBetween: 40,
                                },
                            }}
                        >
                            <SwiperSlide>
                                <div className="portfolio__box">
                                    <img src="https://swiperjs.com/demos/images/nature-1.jpg" alt="portfolio" />
                                    <div className="portfolio__technology">
                                        <button className="tech__btn react__btn">React</button>
                                        <button className="tech__btn html__btn">HTML</button>
                                        <button className="tech__btn css__btn">CSS</button>
                                        <button className="tech__btn router__btn">React Router</button>
                                        <button className="tech__btn firebase__btn">Firebase</button>
                                    </div>
                                    <h5 className="portfolio__title">Hot Gadget e-commerce Website</h5>
                                    <p className="portfolio__desc">
                                        Open source projects, web apps and experimentals. Open source projects, web apps and experimentals.
                                    </p>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="portfolio__box">
                                    <img src="https://swiperjs.com/demos/images/nature-2.jpg" alt="portfolio" />
                                    <div className="portfolio__technology">
                                        <button className="tech__btn react__btn">React</button>
                                        <button className="tech__btn html__btn">HTML</button>
                                        <button className="tech__btn css__btn">CSS</button>
                                        <button className="tech__btn router__btn">React Router</button>
                                        <button className="tech__btn firebase__btn">Firebase</button>
                                    </div>
                                    <h5 className="portfolio__title">Hot Gadget e-commerce Website</h5>
                                    <p className="portfolio__desc">
                                        Open source projects, web apps and experimentals. Open source projects, web apps and experimentals.
                                    </p>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="portfolio__box">
                                    <img src="https://swiperjs.com/demos/images/nature-3.jpg" alt="portfolio" />
                                    <div className="portfolio__technology">
                                        <button className="tech__btn react__btn">React</button>
                                        <button className="tech__btn html__btn">HTML</button>
                                        <button className="tech__btn css__btn">CSS</button>
                                        <button className="tech__btn router__btn">React Router</button>
                                        <button className="tech__btn firebase__btn">Firebase</button>
                                    </div>
                                    <h5 className="portfolio__title">Hot Gadget e-commerce Website</h5>
                                    <p className="portfolio__desc">
                                        Open source projects, web apps and experimentals. Open source projects, web apps and experimentals.
                                    </p>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="portfolio__box">
                                    <img src="https://swiperjs.com/demos/images/nature-4.jpg" alt="portfolio" />
                                    <div className="portfolio__technology">
                                        <button className="tech__btn react__btn">React</button>
                                        <button className="tech__btn html__btn">HTML</button>
                                        <button className="tech__btn css__btn">CSS</button>
                                        <button className="tech__btn router__btn">React Router</button>
                                        <button className="tech__btn firebase__btn">Firebase</button>
                                    </div>
                                    <h5 className="portfolio__title">Hot Gadget e-commerce Website</h5>
                                    <p className="portfolio__desc">
                                        Open source projects, web apps and experimentals. Open source projects, web apps and experimentals.
                                    </p>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="portfolio__box">
                                    <img src="https://swiperjs.com/demos/images/nature-5.jpg" alt="portfolio" />
                                    <div className="portfolio__technology">
                                        <button className="tech__btn react__btn">React</button>
                                        <button className="tech__btn html__btn">HTML</button>
                                        <button className="tech__btn css__btn">CSS</button>
                                        <button className="tech__btn router__btn">React Router</button>
                                        <button className="tech__btn firebase__btn">Firebase</button>
                                    </div>
                                    <h5 className="portfolio__title">Hot Gadget e-commerce Website</h5>
                                    <p className="portfolio__desc">
                                        Open source projects, web apps and experimentals. Open source projects, web apps and experimentals.
                                    </p>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className="portfolio__box">
                                    <img src="https://swiperjs.com/demos/images/nature-6.jpg" alt="portfolio" />
                                    <div className="portfolio__technology">
                                        <button className="tech__btn react__btn">React</button>
                                        <button className="tech__btn html__btn">HTML</button>
                                        <button className="tech__btn css__btn">CSS</button>
                                        <button className="tech__btn router__btn">React Router</button>
                                        <button className="tech__btn firebase__btn">Firebase</button>
                                    </div>
                                    <h5 className="portfolio__title">Hot Gadget e-commerce Website</h5>
                                    <p className="portfolio__desc">
                                        Open source projects, web apps and experimentals. Open source projects, web apps and experimentals.
                                    </p>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Portfolio;